import { Controller } from '@hotwired/stimulus'

export default class BankAccountFormController extends Controller {
  static targets = ['container']

  static values = {
    successMessage: String,
    successTitle: String,
    errorTitle: String,
    genericError: String
  }

  async submit(event) {
    event.preventDefault()

    const form = event.target
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: form.method,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: formData
      })

      const data = await response.json()
      this.handleResponse(data)
    } catch (error) {
      toastr.error(this.genericErrorValue, this.errorTitleValue, { closeButton: true })
    }
  }

  handleResponse(data) {
    if (data.identity_verification_required) {
      this.#showOtpModal()
      return
    }

    if (!data.success) {
      toastr.error(data.error, this.errorTitleValue, { closeButton: true })
      return
    }

    this.#hideOtpModal()
    this.#updateContainer(data.html)
    toastr.success(this.successMessageValue, this.successTitleValue, { closeButton: true })
  }

  #updateContainer(html) {
    if (this.hasContainerTarget) {
      this.containerTarget.innerHTML = html
    }
  }

  #showOtpModal() {
    const otpModal = document.querySelector('#otpModal')
    if (otpModal) {
      const controller = this.application.getControllerForElementAndIdentifier(otpModal, 'otp-modal')
      if (controller) {
        controller.show()
      }
    }
  }

  #hideOtpModal() {
    const otpModal = document.querySelector('#otpModal')
    if (otpModal) {
      const controller = this.application.getControllerForElementAndIdentifier(otpModal, 'otp-modal')
      if (controller) {
        controller.hide()
      }
    }
  }
}
